export default function Tablet(props: any) {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M40.5 35.25V12.75C40.5 11.5074 39.4926 10.5 38.25 10.5H9.75C8.50736 10.5 7.5 11.5074 7.5 12.75V35.25C7.5 36.4926 8.50736 37.5 9.75 37.5H38.25C39.4926 37.5 40.5 36.4926 40.5 35.25Z"
                stroke="white"
                strokeWidth="2.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M20 33H28" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
